import styled from 'styled-components';
import Box from '@mui/material/Box';

export const StyledVideoWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 8px;
`;
